__turbopack_context__.v({
  "fadeIn": "Toaster-module-scss-module__h4IyMW__fadeIn",
  "toastAnimation": "Toaster-module-scss-module__h4IyMW__toastAnimation",
  "toastContainer": "Toaster-module-scss-module__h4IyMW__toastContainer",
  "toastWrapper": "Toaster-module-scss-module__h4IyMW__toastWrapper",
});
